import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Authorization } from '../../model/authorization';
import { AuthRoles_PTBR } from '../../model/AuthRoles';
import { AuthorizationService } from '../../service/authorizationService';
import { BasicAuthorization } from '../../model/basic-authorization';
import { UserService } from '../../service/user.service';
import { Essentials } from '../../util/essentials';
import { DatePipe } from '@angular/common';
import { Invite } from '../../model/invite';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invitation-card',
  templateUrl: './invitation-card.component.html',
  styleUrls: ['./invitation-card.component.css']
})
export class InvitationCardComponent implements OnInit {

  @Input() invite: Invite;
  @Input() authorization: BasicAuthorization;
  @Input() lobbyRelease: boolean = false;
  @Output() cardClicked: EventEmitter<any> = new EventEmitter();
  @Output() collapsedClicked: EventEmitter<any> = new EventEmitter();

  thumbnail: any = '';
  constructor(
    private essentials: Essentials,
    private userService: UserService,
    private authorizationService: AuthorizationService,
    public datepipe: DatePipe,
    private translate: TranslateService
  ) {
    this.thumbnail = essentials.getDefaultAvatar();
  }

  ngOnInit(): void {
    let updatedAt = Date.parse(this.authorization.userUpdatedAt);
    if (this.authorization.userId != 0) {
      this.userService.getThumbnail(this.authorization.userId, updatedAt.valueOf())
        .subscribe(data => {
          this.thumbnail = data.thumbnail;
        });
    }
  }

  onCardClick() {
    if (this.invite == undefined)
      return;

    this.cardClicked.emit(this.invite);
  }

  onCollapsedClicked() {
    if (this.invite == undefined)
      return;

    this.collapsedClicked.emit(this.invite);
  }

  getInviteName() {
    if (this.invite.unitOwner) {
      let start = this.datepipe.transform(this.authorization.validPeriodStartsAt, 'dd/MM/yy HH:mm');
      return `${this.translate.instant('INVITES.PAGE.IMPORTED_USERS_IN')} ${start}`;
    }
    else return this.invite.inviteDescription;
  }

  getFormatedInvitePeriod() {
    if (!this.isNullOrEmpty(this.authorization.validPeriodStartsAt) && !this.isNullOrEmpty(this.authorization.validPeriodEndsAt)) {
      let start = this.datepipe.transform(this.authorization.validPeriodStartsAt, 'dd/MM/yy HH:mm');
      let end = this.datepipe.transform(this.authorization.validPeriodEndsAt, 'dd/MM/yy HH:mm');
      return `${start} - ${end}`;
    }
    return '--'
  }

  getFormatedValidPeriodStartsAt() {
    if (!this.isNullOrEmpty(this.authorization.validPeriodStartsAt)) {
      let validPeriodStartsAt = new Date(this.authorization.validPeriodStartsAt)
      return this.datepipe.transform(validPeriodStartsAt, 'dd/MM/yy HH:mm');
    }
  }

  getFormatedValidPeriodEndsAt() {
    if (!this.isNullOrEmpty(this.authorization.validPeriodEndsAt)) {
      let validPeriodEndsAt = new Date(this.authorization.validPeriodEndsAt)
      return this.datepipe.transform(validPeriodEndsAt, 'dd/MM/yy HH:mm');
    }
  }

  isNullOrEmpty(value: string) {
    return value == undefined || value == null || value.trim() == '';
  }

  get showLobbyRelease() {
    return this.lobbyRelease && this.authorization.waitOnLobby && this.authorization.userId != 0 && this.authorization.status < 3;
  }

}
